import SelectSearchDropDown from 'Components/Form/SearchDropDown/SelectSearchDropDown';
import React, { useRef } from 'react';

export interface DDLItem {
  id: string | number;
  label: string;
}
const AllOption: DDLItem = { id: 'all', label: 'All' };

export const DDLWrap = (options: string[]) =>
  options.map((o) => ({ id: o, label: _.capitalize(o) } as DDLItem));

export default function SelectDropDown<T extends string | number>({
  value,
  options,
  onChange,
  withAll = false,
  clearable = false,
  searchable = false,
  placeholder,
  disabled,
}: {
  value?: T;
  placeholder?: string;
  searchable?: boolean;
  clearable?: boolean;
  onChange: (v: T | undefined) => void;
  options: DDLItem[];
  withAll?: boolean;
  disabled?: boolean;
}) {
  const _options = withAll ? [AllOption].concat(options) : options;
  const _value = withAll && value === undefined ? AllOption.id : value;

  const onChangeHandle = (value?: string | number) => {
    const newValue = withAll && value === AllOption.id ? undefined : value;
    onChange(newValue as unknown as T);
  };
  return (
    <SelectSearchDropDown
      placeHolder={placeholder}
      disabled={disabled}
      showSelectedInOptions={true}
      clearable={clearable}
      searchable={searchable}
      valueId={_value}
      options={_options}
      onChangeId={onChangeHandle}
      optionItemSkin={(x) => <span className="capitalize">{x.label}</span>}
      selectedItemSkin={(x) => <span className="capitalize">{x.label}</span>}
    />
  );
}
